module.exports = __webpack_public_path__ + "img/joystick.22e3ff58.svg";